var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductDescriptionTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#EF1671"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25781 12.4453C8.25781 12.0311 8.59052 11.6953 9.00095 11.6953H25.5147C25.9251 11.6953 26.2578 12.0311 26.2578 12.4453C26.2578 12.8595 25.9251 13.1953 25.5147 13.1953H9.00095C8.59052 13.1953 8.25781 12.8595 8.25781 12.4453Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25781 8.48438C8.25781 8.07016 8.60135 7.73438 9.02513 7.73438H29.4866C29.9104 7.73438 30.2539 8.07016 30.2539 8.48438C30.2539 8.89859 29.9104 9.23438 29.4866 9.23438H9.02513C8.60135 9.23438 8.25781 8.89859 8.25781 8.48438Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25781 16.4102C8.25781 15.9959 8.57474 15.6602 8.96569 15.6602H21.5499C21.9409 15.6602 22.2578 15.9959 22.2578 16.4102C22.2578 16.8244 21.9409 17.1602 21.5499 17.1602H8.96569C8.57474 17.1602 8.25781 16.8244 8.25781 16.4102Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9084 14.6858C28.2812 14.8739 28.4834 15.2871 28.4031 15.6968L27.4466 20.5767L31.1434 21.9913C31.4314 22.1015 31.6461 22.347 31.7171 22.647C31.7881 22.947 31.706 23.2627 31.4979 23.4902L23.7474 31.9638C23.4656 32.2719 23.0132 32.3549 22.6403 32.1668C22.2675 31.9787 22.0654 31.5656 22.1457 31.1558L23.1021 26.2759L19.4054 24.8613C19.1174 24.7512 18.9026 24.5057 18.8317 24.2056C18.7607 23.9056 18.8428 23.5899 19.0509 23.3624L26.8014 14.8888C27.0832 14.5807 27.5356 14.4977 27.9084 14.6858Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductDescriptionTool);
export default __webpack_public_path__ + "static/media/product-description-tool.a927560bd38ae9aa82a98acbe8891803.svg";
export { ForwardRef as ReactComponent };